/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb3_DescriptionInputs */

const en_visa_eb3_description = /** @type {(inputs: Visa_Eb3_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The EB-3 category can provide a path to permanent residence through a qualifying U.S. job opportunity. In many cases, the process involves employer sponsorship and labor certification, with requirements that depend on the position and the applicant's background.`)
};

const pt_visa_eb3_description = /** @type {(inputs: Visa_Eb3_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A categoria EB-3 pode oferecer um caminho para a residência permanente por meio de uma oportunidade de emprego que atenda aos requisitos nos EUA. Em muitos casos, o processo envolve patrocínio do empregador e certificação trabalhista, com requisitos que dependem do cargo e da formação do candidato.`)
};

const es_visa_eb3_description = /** @type {(inputs: Visa_Eb3_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La categoría EB-3 puede proporcionar un camino hacia la residencia permanente a través de una oportunidad de empleo calificada en EE. UU. En muchos casos, el proceso implica patrocinio del empleador y certificación laboral, con requisitos que dependen del puesto y la formación del solicitante.`)
};

/**
* | output |
* | --- |
* | "The EB-3 category can provide a path to permanent residence through a qualifying U.S. job opportunity. In many cases, the process involves employer sponsorsh..." |
*
* @param {Visa_Eb3_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb3_description = /** @type {((inputs?: Visa_Eb3_DescriptionInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb3_DescriptionInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb3_description(inputs)
	if (locale === "es") return es_visa_eb3_description(inputs)
	return en_visa_eb3_description(inputs)
});